import React from 'react';
import PropTypes from 'prop-types';


const ContributorSection = ({data}) => {
    const {contributorType, contributor = []} = data;
    return (
        <div className="contributor-section col-md-12">
            <h3>{contributorType}</h3>
            <div className="contributor-list">
                {contributor.length > 0 &&  
                    contributor.map((user, i) => {
                        return (
                            <div className="contributor col-xs-6 col-sm-6 col-md-4 col-lg-2" key={`${user.nickName}-${i}`}>
                                <div className="tile-box">
                                    <div className="tile-image">
                                        <span className="nickname">{user.nickName}</span>
                                        <img src={user.picture} className="img-responsive" alt={user.nickName}/>
                                    </div>
                                    <div className="tile-content">
                                        <div className="tile-type">{user.contribution}</div>
                                        <h5>{user.name}</h5>
                                        <p>{user.quote}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

ContributorSection.propTypes = {
    data: PropTypes.shape({
        contributorType: PropTypes.string,
        contributor: PropTypes.array
    })
}

export default ContributorSection
